var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.333 4.667l.884 8.7c.017.17.16.3.332.3h6.736c.169 0 .31-.126.331-.294l1.05-8.706m-9.333 0h-2m2 0H5m7.667 0h1.666m-1.666 0H11m-6 0v-2c0-.184.15-.334.333-.334h5.334c.184 0 .333.15.333.334v2m-6 0h6"
  })));
}
export default SvgTrashIcon;